import React, {FormEvent, useEffect, useState} from "react";
import {Button, Modal, Col, Row, Form} from "react-bootstrap";
import * as Inputs from '../../inputs';
import VerticalInputElementForm from "../../components/VerticalInputElementForm/VerticalInputElementForm";
import styles from './VerificationCodeModal.module.scss';

type VerificationCodeProps = {
    form: VerificationCodeForm;
    show: boolean;
    formValid: boolean;
    on_hide: () => void;
    onFormChange: ((key: string, value: any) => void) | ((key: string, value: any) => Promise<void>);
    onVerificationCodeResend: () => void;
    title?: React.ReactNode;
    body?: React.ReactNode;
    size?: 'sm' | 'lg' | 'xl';
    onSubmit: (event: FormEvent) => Promise<void>;
};

interface VerificationCodeForm extends Record<string, Inputs.InputField> {
    verification_code: Inputs.TextField;
    email: Inputs.ReadOnlyText;
}

const VerificationCodeModal = (props: VerificationCodeProps) => {
  const {
    form,
    show,
    formValid,
    on_hide,
    onFormChange,
    onVerificationCodeResend,
    onSubmit,
    title,
    body,
    size,
  } = props;

    const render_body = () =>  (
        
        <Col>
            <Form onSubmit={onSubmit}>
                <p>For your security, a confirmation code has been sent to <b>{form.email.value}</b>.</p>
                <ul>
                    <li>Please check your email and enter the code below.</li>
                    <li>After you enter your verification code you will be <u>directed to the login page</u>.</li>
                    <li className={styles.BoldLine}>Please login to <u>FINISH</u> the process and activate your account.</li>
                </ul>
                <VerticalInputElementForm
                    fields={form}
                    changed={onFormChange}
                    group_className={'mb-3'}
                    label_className={'fw-bold'}
                    included_keys={['verification_code']} />
                <Row>
                    <Col className={'d-flex justify-content-center mb-3'}>
                        <Button
                            type={'submit'}
                            variant={'teal'}
                            className={`px-5 ${styles.BigButton}`}
                            disabled={!formValid}
                        >Submit</Button>
                    </Col>
                </Row> 
                <Row>
                    <Col className={'text-center mb-2'}>
                    </Col>
                </Row>
                  
            </Form>
            <Row className={'mb-1 mt-2'}>
                <Col className={'text-center'}>
                    <Button
                            type={'submit'}
                            variant={'link'}
                            onClick={onVerificationCodeResend}
                        >Resend Code</Button>
                </Col>
            </Row>     
        </Col>
    );

    return (
        <Modal show={show} onHide={on_hide} size={size}>
            <Modal.Header className={styles.ShortHeader}>
                <Modal.Title className={'me-auto ms-auto text-center'}>{title ?? 'Welcome to Consent On Demand!'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {render_body()}     
            </Modal.Body>
        </Modal>
    );
}

export default VerificationCodeModal;
